export default (params) => ({
  trigger: {
    name: 'content_blocks.product_line_comparison.select_property',
    params: params,
  },
  config: {
    schema: {
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
        content: 'property',
      },
    },
    nonInt: false,
  },
});
